<template>
  <div class="the-tab-menu">
    <div class="door-config__tab-menu__item" v-for="(filterNav, indexNav) in groupAndSort" :key="indexNav"
      @click="$emit('clickTab', index, filterNav, indexNav)">
      <span v-if="filterNav.category" class="door-config__tab-menu__link tabs-link" @click.prevent :class="{
        _active: activeTabIndex == indexNav,
      }">{{ filterNav.category }}</span>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    groupAndSort() {
      let { prices, pictureText, ...obj } = this.filter
      return obj
    },
  },
  props: {
    index: [String, Number],
    filter: [Object, Array],
    activeTabIndex: [String, Number],
  },
  emits: ['clickTab'],
};
</script>
<style>
.the-tab-menu {
  display: contents;
}
</style>